import React from 'react'
import { getLocal } from '../utils/local'
import defaultRoutes from '../constants/defaultRoutes'

const usePermission = () => {
  const userPermissions: string[] = getLocal('permissions')

  const getDefaultRoute = React.useCallback((permissions?: string[]) => {
    if (!permissions) {
      return defaultRoutes.default
    }
    let permission: any = permissions[0]

    if (permissions.includes('admin') || permissions.includes('owner')) {
      return defaultRoutes.admin
    } else if (Object.hasOwn(defaultRoutes, permission) && permission) {
      return defaultRoutes[permission]
    } else {
      return defaultRoutes.default
    }
  }, [])

  const hasPermissions = React.useCallback(
    (permissions?: string[]): boolean => {
      let allowed = false
      if (!permissions || !permissions.length) {
        return true
      }
      if (!userPermissions) {
        return false
      }

      for (let i = 0; i < permissions.length; i++) {
        const passed = userPermissions.includes(permissions[i])
        if (passed) return passed
      }
      return allowed
    },
    [userPermissions]
  )

  return {
    hasPermissions,
    getDefaultRoute,
    defaultRoute: defaultRoutes.default,
  }
}

export default usePermission
